module.exports = __webpack_public_path__ + "static/img/aboutUS_pyjsb.5104af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUS_pyjsb.png
// module id = ZtWY
// module chunks = 1